import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaMobileAlt } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const BACKEND_URL = "https://overair.onrender.com";

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${BACKEND_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        toast.error(data.message || "Something went wrong.");
      }
    } catch (error) {
      toast.error("Failed to send message.");
    }
  };

  return (
    
    <Container  id="contact" className="my-5 pt-5">
        <h2
    className="text-center fw-bold mb-3"
    style={{
      fontFamily: 'Poppins, sans-serif',
      fontSize: '2.5rem',
      paddingTop: '40px'
    }}
  >
    Contact Us
  </h2>

  <p
    className="text-center text-muted mb-5"
    style={{
      fontFamily: 'Open Sans, sans-serif',
      fontSize: '1.25rem',
      lineHeight: '1.6'
    }}
  >
    We'd love to hear from you! Fill out the form or reach us directly.
  </p>

      <Row className="gy-4">
        {/* Contact Form */}
        <Col md={6}>
          <Card className="p-4 shadow-sm border-2">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label>Your Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMessage">
                <Form.Label>Your Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Write your message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="w-100">
                Send Message
              </Button>
            </Form>
          </Card>
        </Col>

        {/* Contact Info */}
        <Col md={6}>
          <Card className="p-4 shadow-sm border-2 h-100">
            <div className="mb-3">
              <FaMapMarkerAlt className="me-2 text-primary" />
              <strong>Address:</strong>
              <p className="ms-4 mb-0">
                A2/132 Site 5, Kasna, Greater Noida, Uttar Pradesh
              </p>
            </div>

            <div className="mb-3">
              <FaPhoneAlt className="me-2 text-primary" />
              <strong>Phone:</strong>
              <p className="ms-4 mb-0">
                <a href="tel:+919205936005" className="text-decoration-none text-dark">
                  +91 9205936005
                </a>
              </p>
            </div>

            <div className="mb-3">
              <FaMobileAlt className="me-2 text-primary" />
              <strong>Mobile:</strong>
              <p className="ms-4 mb-0">
                <a href="tel:+919205936005" className="text-decoration-none text-dark">
                  +91 9205936005
                </a>
              </p>
            </div>

            <div className="mb-3">
              <FaEnvelope className="me-2 text-primary" />
              <strong>Email:</strong>
              <p className="ms-4 mb-0">
                <a href="mailto:itsupport@alignedvertical.com" className="text-decoration-none text-dark">
                  itsupport@alignedvertical.com
                </a>
              </p>
            </div>

            <div className="mt-3">
              <iframe
                title="AV Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28042.587478871115!2d77.515996!3d28.49836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa032d3538a66ffc5%3A0x2cc85e473eab372c!2sOverAir%20Product%20%26%20Services%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1716212345678!5m2!1sen!2sin"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </Card>
        </Col>
      </Row>

      <ToastContainer position="top-center" autoClose={3000} />
    </Container>
  );
};

export default ContactUs;
